module.exports = __webpack_public_path__ + "img/img-dragon.e65b786b.png";